module.exports = __webpack_public_path__ + "img/logo.acb7faa7.png";